export default "__VITE_ASSET__vwNRJuGU__"